// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__HbE8y","right":"styles_right__GcUfH"};